export function trackMarketingEvent(eventName, attributes = {}) {
    window.dataLayer = window.dataLayer || [];
    const tagManagerEvent = { event: eventName, ...attributes };
    window.dataLayer.push(tagManagerEvent);
}
//# sourceMappingURL=marketing.js.map